import React, { useState } from "react";
import { Dialog } from "@mui/material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { AuthLogin } from "./AuthLogin";
import  AuthEmail  from "./AuthEmail";
import {  useDispatch } from 'react-redux';
import AuthOtp from "src/components/home/authpopup/AuthOtp.js"
import { closeAuthModal } from "src/redux/slices/authSlice.js"

const Authpopup = ({ open }) => {
  const [ authStep , setAuthStep] = useState(0)
  const [userEmail,setUserEmail] = useState("")
  const [isForgot,setIsForgot] = useState(false)
  const [userPassword,setUserPassword] = useState("")
  const [flowId,setFlowId] = useState("")
  const dispatch = useDispatch()

  const getUserEmail = (email) => { setUserEmail(email)}
  const getUserPassword = (email) => { setUserPassword(email)}
  const getFlowId = (id) => { setFlowId(id)}

  function handleClose(){
    setAuthStep(0)
    dispatch(closeAuthModal())
  }

  const authForm = [
    <AuthLogin onForgot={()=>setIsForgot(false)} onStepChange={(idx)=>setAuthStep(idx)} onGetEmail={getUserEmail} onGetPassword={getUserPassword} onGetFlowId={getFlowId} handleClose={handleClose}/>,
    <AuthEmail onForgot={()=>setIsForgot(true)} onStepChange={(idx)=>setAuthStep(idx)} onGetEmail={getUserEmail}  handleClose={handleClose}/>,
    <AuthOtp onForgot={()=>setIsForgot(false)} isForgot={isForgot} userEmail={userEmail} userPassword={userPassword} flowId={flowId} onStepChange={(idx)=>setAuthStep(idx)}  handleClose={handleClose}/>,
  ]
 
  return (
    <Dialog
      open={open}
      onClose={()=>{
        if(authStep != 2){
          handleClose()}}
        }
      fullWidth
      sx={{
        "& .MuiPaper-root ": {
          maxWidth: "660px",
          margin: "0 auto",
        },
      }}
    >
      {authForm[authStep]}
    </Dialog>
  );
};

export default Authpopup;
